import { render, staticRenderFns } from "./gameHeader.vue?vue&type=template&id=9296fcaa&scoped=true"
import script from "./gameHeader.vue?vue&type=script&lang=js"
export * from "./gameHeader.vue?vue&type=script&lang=js"
import style0 from "./gameHeader.vue?vue&type=style&index=0&id=9296fcaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9296fcaa",
  null
  
)

export default component.exports